import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {POLL_INTERVAL} from '../../constants';
import {GroupBooking} from '../../graphql/groups.datatypes';
import {gqlGroupBooking} from './getGroupBooking.api';

interface GroupBookingData {
    groupBooking?: void,
    myGroupBooking: GroupBooking
}

export const GET_MY_GROUP_BOOKING_QUERY = gql`
    query getMyGroupBooking($id: Int!){
        myGroupBooking(id: $id){
          ${gqlGroupBooking}
        }
    }
`;

export const getMyGroupBooking = (partyId: number | null, poll: boolean = true) => {
    const id = partyId ? partyId : -1;
    return useQuery<GroupBookingData>(
        GET_MY_GROUP_BOOKING_QUERY,
        {
            fetchPolicy: 'no-cache',
            variables: {id},
            pollInterval: poll ? POLL_INTERVAL : undefined,
        }
    );
};

export default getMyGroupBooking;